import SpotsPage from 'spots/presentation/components/spots.page'

const SpotsFactory = () => {
  return <SpotsPage />
}

export default SpotsFactory
